import {PureComponent} from 'react'

class PostMessage extends PureComponent {

	constructor(props) {
		super(props)
		this.onWindowMessage = this.onWindowMessage.bind(this)
	}

	onWindowMessage(ev) {
		if (ev && ev.data && ev.data.type === 'np_message' && this.props.onMessageEvent) {
			this.props.onMessageEvent(ev.data)
		}
	}

	componentDidMount() {
		window.addEventListener('message', this.onWindowMessage, false)
	}

	componentWillUnmount() {
		window.removeEventListener('message', this.onWindowMessage, false)
	}

	render() {
		return (this.props.children)
	}
}

export default PostMessage
